import * as React from 'react';
import { Modal } from '@teamsnap/teamsnap-ui';
import { Icon, LabelButton } from '@teamsnap/snap-ui';

import './OfflinePaymentConfirmationModal.scss';

interface Props {
  onEnabled: () => void;
  onRedirect: () => void;
  show: boolean;
}

const OfflinePaymentConfirmationModal = ({ onEnabled, onRedirect, show }: Props) => {
  const handleClose = () => {};

  return (
    <>
      {show ? (
        <Modal
          testId="offline-payment-confirmation-modal"
          heading={
            <div className="sui-flex sui-items-center sui-max-w-screen-t">
              <div className="sui-pt-1 sui-mr-2">
                <Icon className="sui-text-yellow-70" filled name="warning" size="xl" />
              </div>

              <div className="sui-heading-sm">Enable cash payments for all registrants?</div>
            </div>
          }
          closeFn={handleClose}
          show={true}
        >
          <>
            <div className="sui-body sui-py-4">
              <p className="sui-pt-2 sui-mb-3">
                Enabling cash payments makes this method available to all registrants on this form.
              </p>

              <p className="sui-mb-3">
                If you plan to accept a limited number of cash payments, create unique discount codes to zero out
                balances for certain registrants to make cash payments directly to you.
              </p>

              <p className="sui-mb-6">
                <strong>Tip:</strong> Provide clear instructions for cash payments in the registration confirmation
                message.
              </p>
            </div>

            <div className="sui-flex sui-pt-2 sui-justify-end">
              <LabelButton
                labelText="Enable cash payments"
                variantType="secondary"
                className="sui-px-3 sui-mr-1 sui-cursor-pointer"
                onClick={() => onEnabled()}
              />

              <LabelButton
                labelText="Set up discount codes"
                variantType="primary"
                className="sui-px-3 sui-cursor-pointer"
                onClick={() => onRedirect()}
              />
            </div>
          </>
        </Modal>
      ) : null}
    </>
  );
};

export default OfflinePaymentConfirmationModal;
